var map = {
	"./arg.svg": 2247,
	"./aus.svg": 2248,
	"./bel.svg": 2249,
	"./bra.svg": 2250,
	"./can.svg": 2251,
	"./cmr.svg": 2252,
	"./crc.svg": 2253,
	"./cro.svg": 2254,
	"./den.svg": 2255,
	"./ecu.svg": 2256,
	"./eng.svg": 2257,
	"./esp.svg": 2258,
	"./fra.svg": 2259,
	"./ger.svg": 2260,
	"./gha.svg": 2261,
	"./irn.svg": 2262,
	"./jpn.svg": 2263,
	"./kor.svg": 2264,
	"./ksa.svg": 2265,
	"./mar.svg": 2266,
	"./mex.svg": 2267,
	"./ned.svg": 2268,
	"./pol.svg": 2269,
	"./por.svg": 2270,
	"./qat.svg": 2271,
	"./sen.svg": 2272,
	"./srb.svg": 2273,
	"./sui.svg": 2274,
	"./tun.svg": 2275,
	"./uru.svg": 2276,
	"./usa.svg": 2277,
	"./wal.svg": 2278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;